import { render, staticRenderFns } from "./login1.vue?vue&type=template&id=705515a2&scoped=true"
import script from "./login1.vue?vue&type=script&lang=js"
export * from "./login1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705515a2",
  null
  
)

export default component.exports